import { render, staticRenderFns } from "./BasicBtn.vue?vue&type=template&id=3f114ab5&scoped=true"
import script from "./BasicBtn.vue?vue&type=script&lang=js"
export * from "./BasicBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f114ab5",
  null
  
)

export default component.exports